import React from "react";
import styled from "styled-components";

const Link = ({ children, ...props }) => {
    return (
        <LinkEle {...props}>
            {children}
        </LinkEle>
    );
};

const LinkEle = styled.a`
  color: var(--aia-bx-blue-2);
  cursor: pointer;
  text-decoration: underline;
`;

export default Link;